import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [procurementOpen, setProcurementOpen] = useState(false);
  return <header className="bg-white border-b border-gray-border sticky top-0 z-50" data-id="element-227">
      <div className="max-w-7xl mx-auto px-4" data-id="element-228">
        <div className="flex items-center justify-between h-20" data-id="element-229">
          <Link to="/" className="flex items-center gap-3" data-id="element-230">
            <img src="https://cdn.magicpatterns.com/uploads/dUQRpLPA28c7QtfR6xGyBP/Logo.png" alt="African Union Commission" className="w-12 h-12 object-contain" data-id="element-231" />
            <div data-id="element-232">
              <div className="font-serif text-xl font-bold" style={{
              color: '#8B1A2C'
            }} data-id="element-233">
                African Union
              </div>
              <div className="text-sm text-gray-600" data-id="element-234">Commission</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-8" data-id="element-235">
            <Link to="/" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-236">
              Home
            </Link>
            <Link to="/about" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-237">
              About
            </Link>
            <Link to="/projects" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-238">
              Projects
            </Link>
            <Link to="/bids" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-239">
              Bids & Tenders
            </Link>

            <div className="relative" onMouseEnter={() => setProcurementOpen(true)} onMouseLeave={() => setProcurementOpen(false)} data-id="element-240">
              <button className="flex items-center gap-1 text-charcoal hover:text-au-green transition-colors font-medium py-2" data-id="element-241">
                Procurement
                <ChevronDownIcon size={16} data-id="element-242" />
              </button>

              {procurementOpen && <div className="absolute top-full left-0 pt-2 w-56 z-50" data-id="element-243">
                  <div className="bg-white rounded-lg shadow-lg border border-gray-border py-2" data-id="element-244">
                    <Link to="/procurement/annual-plan" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-245">
                      Annual Plan
                    </Link>
                    <Link to="/procurement/contract-awards" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-246">
                      Contract Awards
                    </Link>
                    <Link to="/procurement/unsuccessful-bids" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-247">
                      Unsuccessful Bids
                    </Link>
                    <Link to="/procurement/manual" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-248">
                      Procurement Manual
                    </Link>
                    <Link to="/procurement/supplier-registration" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-249">
                      Supplier Registration
                    </Link>
                  </div>
                </div>}
            </div>

            <Link to="/contact" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-250">
              Contact
            </Link>
          </nav>

          <button className="lg:hidden" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-251">
            {mobileMenuOpen ? <XIcon size={24} data-id="element-252" /> : <MenuIcon size={24} data-id="element-253" />}
          </button>
        </div>

        {mobileMenuOpen && <nav className="lg:hidden py-4 border-t border-gray-border" data-id="element-254">
            <Link to="/" className="block py-2 hover:text-au-green transition-colors" data-id="element-255">
              Home
            </Link>
            <Link to="/about" className="block py-2 hover:text-au-green transition-colors" data-id="element-256">
              About
            </Link>
            <Link to="/projects" className="block py-2 hover:text-au-green transition-colors" data-id="element-257">
              Projects
            </Link>
            <Link to="/bids" className="block py-2 hover:text-au-green transition-colors" data-id="element-258">
              Bids & Tenders
            </Link>
            <div className="py-2" data-id="element-259">
              <div className="font-medium mb-2" data-id="element-260">Procurement</div>
              <Link to="/procurement/annual-plan" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-261">
                Annual Plan
              </Link>
              <Link to="/procurement/contract-awards" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-262">
                Contract Awards
              </Link>
              <Link to="/procurement/unsuccessful-bids" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-263">
                Unsuccessful Bids
              </Link>
              <Link to="/procurement/manual" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-264">
                Procurement Manual
              </Link>
              <Link to="/procurement/supplier-registration" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-265">
                Supplier Registration
              </Link>
            </div>
            <Link to="/contact" className="block py-2 hover:text-au-green transition-colors" data-id="element-266">
              Contact
            </Link>
          </nav>}
      </div>
    </header>;
}